import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-752039b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "基础问题")
], -1))
const _hoisted_2 = { style: {"padding":"15px 23% 0"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "拓店信息")
], -1))
const _hoisted_4 = { style: {"padding":"15px 23% 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarryOut = _resolveComponent("CarryOut")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["contentBox", _ctx.noBottomBtn ? 'noBottomBtn ' : ''])
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CarryOut, {
          formState: _ctx.platform.taskPackage.taskSub[0],
          problemKey: "collectItems",
          optionKey: "options",
          isEdit: false
        }, null, 8, ["formState"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["contentBox", _ctx.noBottomBtn ? 'noBottomBtn ' : '']),
      style: {"margin-top":"20px"}
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CarryOut, {
          formState: _ctx.formState.taskPackage.taskSub[0],
          problemKey: "collectItems",
          optionKey: "options",
          taskPackageKey: "taskPackage",
          taskSubKey: "taskSub",
          frequency: 0,
          isMust: 0,
          type: "app",
          platform: _ctx.platform,
          isEdit: _ctx.$route.path.includes('created')
        }, null, 8, ["formState", "platform", "isEdit"])
      ])
    ], 2)
  ]))
}